var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserSmall({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 6C8.04734 6 9.16663 4.88071 9.16663 3.5C9.16663 2.11929 8.04734 1 6.66663 1C5.28591 1 4.16663 2.11929 4.16663 3.5C4.16663 4.88071 5.28591 6 6.66663 6Z",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9616 11C10.9616 9.065 9.03664 7.5 6.66664 7.5C4.29664 7.5 2.37164 9.065 2.37164 11",
    stroke: "#070708",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSmall);
export default __webpack_public_path__ + "static/media/user_small.b5c3f39148a86a7801a05cdd512b9507.svg";
export { ForwardRef as ReactComponent };